export function normalizeCommuterValue(value) {
  return Number(value ?? 0) === 1 ? 1 : 0
}

export function getCommuterLabel(value) {
  return normalizeCommuterValue(value) === 1 ? '通校生' : '住宿生'
}

export function getCommuterTone(value) {
  return normalizeCommuterValue(value) === 1 ? 'info' : 'neutral'
}
